'use client'

import { ReactNode, Suspense } from 'react'
import { Providers } from '@/components/utility/providers'
import { GlobalState } from '@/components/utility/global-state'
import { JotaiProvider } from '@/@providers/JotaiProvider'
import { Toaster } from '@/components/ui/sonner'
import { ClientThemeColorManager } from '@/components/utility/ClientThemeColorManager'
import { ChatbotUIChatProvider } from '@/context/chat'
import { AppShellSkeleton } from '@/components/utility/app-shell-skeleton'

interface PublicChatLayoutProps {
  children: ReactNode
}

export default function PublicChatLayout({ children }: PublicChatLayoutProps) {
  return (
    <Providers attribute="class" defaultTheme="system">
      <ClientThemeColorManager />
      <JotaiProvider>
        <div className="bg-background text-foreground flex size-full flex-col">
          <GlobalState>
            <ChatbotUIChatProvider id={'public'}>
              {/* Paint a real chat-shaped LCP element while the page chunk
                  resolves, instead of weak centered "Loading..." text. */}
              <Suspense fallback={<AppShellSkeleton variant="chat" />}>
                {children}
              </Suspense>
            </ChatbotUIChatProvider>
            <Toaster richColors position="top-center" duration={3000} />
          </GlobalState>
        </div>
      </JotaiProvider>
    </Providers>
  )
}
